"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFilterForDoubleSlider = exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hooks = require("@nicbase/hooks");

var _classnames = _interopRequireDefault(require("classnames"));

var _nicbaseTranslation = require("nicbase-translation");

var _index = require("../index");

var _doubleSliderModule = _interopRequireDefault(require("./double-slider.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var parseStringToValidNumber = function parseStringToValidNumber(dirtyString) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var regex = /^(^-)([^\d])/g;

  if (Number.isInteger(dirtyString)) {
    return dirtyString;
  }

  if (dirtyString) {
    var result = parseInt(dirtyString.replace(regex, ''), 10);

    if (Number.isInteger(result)) {
      return result;
    }
  }

  return min;
};

var useFilterForDoubleSlider = function useFilterForDoubleSlider(_ref) {
  var filters = _ref.filters,
      key = _ref.key,
      min = _ref.min,
      max = _ref.max,
      _ref$initialMin = _ref.initialMin,
      initialMin = _ref$initialMin === void 0 ? min : _ref$initialMin,
      _ref$initialMax = _ref.initialMax,
      initialMax = _ref$initialMax === void 0 ? max : _ref$initialMax;
  var filter = (0, _react.useMemo)(function () {
    var _filters$values$key, _filters$values;

    return (_filters$values$key = (_filters$values = filters.values) === null || _filters$values === void 0 ? void 0 : _filters$values[key]) !== null && _filters$values$key !== void 0 ? _filters$values$key : {
      minValue: initialMin,
      maxValue: initialMax
    };
  }, [filters.values, key, initialMax, initialMin]);
  var update = (0, _react.useCallback)(function (_ref2) {
    var _ref2$minValue = _ref2.minValue,
        minValue = _ref2$minValue === void 0 ? filter.minValue : _ref2$minValue,
        _ref2$maxValue = _ref2.maxValue,
        maxValue = _ref2$maxValue === void 0 ? filter.maxValue : _ref2$maxValue;
    return filters.update(_defineProperty({}, key, {
      minValue: minValue,
      maxValue: maxValue
    }));
  }, [filter.maxValue, filter.minValue, filters, key]);

  var _useState = (0, _react.useState)(filter.minValue),
      _useState2 = _slicedToArray(_useState, 2),
      minValue = _useState2[0],
      setMinValue = _useState2[1];

  var _useState3 = (0, _react.useState)(filter.maxValue),
      _useState4 = _slicedToArray(_useState3, 2),
      maxValue = _useState4[0],
      setMaxValue = _useState4[1];

  var _useState5 = (0, _react.useState)(filter.minValue),
      _useState6 = _slicedToArray(_useState5, 2),
      minInputValue = _useState6[0],
      setMinInputValue = _useState6[1];

  var _useState7 = (0, _react.useState)(filter.maxValue),
      _useState8 = _slicedToArray(_useState7, 2),
      maxInputValue = _useState8[0],
      setMaxInputValue = _useState8[1];

  var debouncedMin = (0, _hooks.useDebounce)(minValue, 400);
  var debouncedMax = (0, _hooks.useDebounce)(maxValue, 400);
  var prevMin = (0, _hooks.usePrevious)(debouncedMin);
  var prevMax = (0, _hooks.usePrevious)(debouncedMax);
  (0, _hooks.useDidUpdate)(function () {
    if (prevMin !== debouncedMin || prevMax !== debouncedMax) {
      update({
        minValue: debouncedMin,
        maxValue: debouncedMax
      });
    }
  }, [debouncedMin, debouncedMax, update, prevMin, prevMax]);
  var onSliderChange = (0, _react.useCallback)(function (_ref3) {
    var newMinValue = _ref3.minValue,
        newMaxValue = _ref3.maxValue;
    setMinValue(newMinValue);
    setMaxValue(newMaxValue);
    setMinInputValue(newMinValue);
    setMaxInputValue(newMaxValue);
  }, []);
  var onInputConfirm = (0, _react.useCallback)(function () {
    var newMinValue = parseStringToValidNumber(minInputValue, min);
    var newMaxValue = parseStringToValidNumber(maxInputValue, min);

    if (minInputValue < min) {
      newMinValue = min;
    }

    if (minInputValue > maxValue) {
      newMinValue = maxValue;
    }

    if (maxInputValue > max) {
      newMaxValue = max;
    }

    if (maxInputValue < minValue) {
      newMaxValue = minValue;
    }

    onSliderChange({
      minValue: newMinValue,
      maxValue: newMaxValue
    });
  }, [max, maxInputValue, maxValue, min, minInputValue, minValue, onSliderChange]);
  var onReset = (0, _react.useCallback)(function () {
    setMinValue(min);
    setMaxValue(max);
    setMinInputValue(min);
    setMaxInputValue(max);
  }, [min, max]);
  return {
    minValue: minValue,
    maxValue: maxValue,
    minInputValue: minInputValue,
    maxInputValue: maxInputValue,
    debouncedMin: debouncedMin,
    debouncedMax: debouncedMax,
    setMinInputValue: setMinInputValue,
    setMaxInputValue: setMaxInputValue,
    onSliderChange: onSliderChange,
    onInputConfirm: onInputConfirm,
    onReset: onReset
  };
};

exports.useFilterForDoubleSlider = useFilterForDoubleSlider;

var DoubleSlider = function DoubleSlider(_ref4) {
  var className = _ref4.className,
      min = _ref4.min,
      max = _ref4.max,
      _ref4$minValue = _ref4.minValue,
      minValue = _ref4$minValue === void 0 ? min : _ref4$minValue,
      _ref4$maxValue = _ref4.maxValue,
      maxValue = _ref4$maxValue === void 0 ? max : _ref4$maxValue,
      maxMinValue = _ref4.maxMinValue,
      minMaxValue = _ref4.minMaxValue,
      onChange = _ref4.onChange,
      sliderClassName = _ref4.sliderClassName,
      minLabel = _ref4.minLabel,
      maxLabel = _ref4.maxLabel,
      seperatorPosition = _ref4.seperatorPosition,
      seperatorLabel = _ref4.seperatorLabel,
      hideInputs = _ref4.hideInputs;

  var _useState9 = (0, _react.useState)(minValue),
      _useState10 = _slicedToArray(_useState9, 2),
      minInputValue = _useState10[0],
      setMinInputValue = _useState10[1];

  var _useState11 = (0, _react.useState)(maxValue),
      _useState12 = _slicedToArray(_useState11, 2),
      maxInputValue = _useState12[0],
      setMaxInputValue = _useState12[1];

  var trackRef = (0, _react.useRef)();
  var range = max - min;

  var onMinSliderChange = function onMinSliderChange(newMinValue) {
    if (maxMinValue !== null && maxMinValue < newMinValue) {
      onChange({
        minValue: maxMinValue,
        maxValue: maxValue
      });
      setMinInputValue(maxMinValue);
    } else if (newMinValue < min) {
      onChange({
        minValue: min,
        maxValue: maxValue
      });
      setMinInputValue(min);
    } else if (newMinValue > maxValue) {
      onChange({
        minValue: maxValue,
        maxValue: maxValue
      });
      setMinInputValue(maxValue);
    } else {
      onChange({
        minValue: newMinValue,
        maxValue: maxValue
      });
      setMinInputValue(newMinValue);
    }
  };

  var onMaxSliderChange = function onMaxSliderChange(newMaxValue) {
    if (minMaxValue !== null && minMaxValue > newMaxValue) {
      onChange({
        minValue: minValue,
        maxValue: minMaxValue
      });
      setMaxInputValue(minMaxValue);
    } else if (newMaxValue > max) {
      onChange({
        minValue: minValue,
        maxValue: max
      });
      setMaxInputValue(max);
    } else if (newMaxValue < minValue) {
      onChange({
        minValue: minValue,
        maxValue: minValue
      });
      setMaxInputValue(minValue);
    } else {
      onChange({
        minValue: minValue,
        maxValue: newMaxValue
      });
      setMaxInputValue(newMaxValue);
    }
  };

  var onTrackClick = function onTrackClick(event) {
    var _trackRef$current$get = trackRef.current.getBoundingClientRect(),
        x = _trackRef$current$get.x,
        width = _trackRef$current$get.width;

    var newValue = Math.round(range * ((event.clientX - x) / width) + min);

    if (newValue < minValue) {
      onMinSliderChange(newValue);
    }

    if (newValue > maxValue) {
      onMaxSliderChange(newValue);
    }
  }; // calculate positions for thumbs and range


  var minSliderPosition = minValue - min;
  var maxSliderPosition = max - maxValue;
  var leftPosition = "".concat(minSliderPosition / range * 100, "%");
  var rightPosition = "".concat(maxSliderPosition / range * 100, "%");
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('relative flex items-center', className)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('relative w-full', sliderClassName)
  }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "sr-only"
  }, minLabel || /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "forms.minSliderLabel",
    tagName: "span"
  })), /*#__PURE__*/_react["default"].createElement("input", {
    className: "appearance-none absolute pointer-events-none z-2 h-3 w-full opacity-0",
    type: "range",
    min: min,
    max: max,
    value: minValue,
    onChange: function onChange(event) {
      return onMinSliderChange(parseInt(event.target.value, 10));
    }
  })), /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "sr-only"
  }, maxLabel || /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "forms.maxSliderLabel",
    tagName: "span"
  })), /*#__PURE__*/_react["default"].createElement("input", {
    className: "appearance-none absolute pointer-events-none z-2 h-3 w-full opacity-0",
    type: "range",
    min: min,
    max: max,
    value: maxValue,
    onChange: function onChange(event) {
      return onMaxSliderChange(parseInt(event.target.value, 10));
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "relative z-1 h-3 mx-2"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute z-1 inset-0 rounded bg-gray-300 cursor-pointer",
    ref: trackRef,
    onClick: onTrackClick
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute z-2 inset-0 rounded bg-primary",
    style: {
      left: leftPosition,
      right: rightPosition
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute z-3 w-4 h-4 bg-primary rounded-full top-1/2 transform -translate-x-1/2 -translate-y-1/2",
    style: {
      left: leftPosition
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute z-3 w-4 h-4 bg-primary rounded-full top-1/2 transform translate-x-1/2 -translate-y-1/2",
    style: {
      right: rightPosition
    }
  }), seperatorPosition !== null && /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute z-3 w-1 h-6 bg-gray-300 shadow top-1/2 transform -translate-x-1/2 -translate-y-1/2",
    style: {
      left: "".concat(Math.abs(seperatorPosition - min) / range * 100, "%")
    }
  }), seperatorPosition !== null && seperatorLabel && /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute transform -translate-x-1/2 translate-y-4",
    style: {
      left: "".concat(Math.abs(seperatorPosition - min) / range * 100, "%")
    }
  }, seperatorLabel), !hideInputs && /*#__PURE__*/_react["default"].createElement("div", {
    className: _doubleSliderModule["default"].minInput,
    style: {
      left: leftPosition
    }
  }, /*#__PURE__*/_react["default"].createElement(_index.Input, {
    className: "w-12 p-0",
    inputClassName: "rounded text-center bg-gray-300 text-sm",
    value: minInputValue,
    onChange: function onChange(newValue) {
      return setMinInputValue(newValue);
    },
    onBlur: function onBlur() {
      return onMinSliderChange(parseStringToValidNumber(minInputValue, min));
    },
    onKeyDown: function onKeyDown(event) {
      return event.keyCode === 13 && event.target.blur();
    },
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "forms.minSliderInput",
      tagName: "span"
    }),
    hideLabel: true
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _doubleSliderModule["default"].bottomInputMarker
  })), !hideInputs && /*#__PURE__*/_react["default"].createElement("div", {
    className: _doubleSliderModule["default"].maxInput,
    style: {
      right: rightPosition
    }
  }, /*#__PURE__*/_react["default"].createElement(_index.Input, {
    className: "w-12 p-0",
    inputClassName: "rounded text-center bg-gray-300 text-sm",
    value: maxInputValue,
    onChange: function onChange(newValue) {
      return setMaxInputValue(newValue);
    },
    onBlur: function onBlur() {
      return onMaxSliderChange(parseStringToValidNumber(maxInputValue, min));
    },
    onKeyDown: function onKeyDown(event) {
      return event.keyCode === 13 && event.target.blur();
    },
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "forms.maxSliderInput",
      tagName: "span"
    }),
    hideLabel: true
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _doubleSliderModule["default"].topInputMarker
  })))));
};

DoubleSlider.propTypes = {
  className: _propTypes["default"].string,
  sliderClassName: _propTypes["default"].string,
  min: _propTypes["default"].number,
  max: _propTypes["default"].number,
  minValue: _propTypes["default"].number.isRequired,
  maxValue: _propTypes["default"].number.isRequired,
  maxMinValue: _propTypes["default"].number,
  minMaxValue: _propTypes["default"].number,
  minLabel: _propTypes["default"].string,
  maxLabel: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  seperatorPosition: _propTypes["default"].number,
  seperatorLabel: _propTypes["default"].node,
  hideInputs: _propTypes["default"].bool
};

var noop = function noop() {};

DoubleSlider.defaultProps = {
  className: '',
  sliderClassName: '',
  min: 0,
  max: 100,
  maxMinValue: null,
  minMaxValue: null,
  minLabel: '',
  maxLabel: '',
  onChange: noop,
  seperatorPosition: null,
  seperatorLabel: null,
  hideInputs: false
};
var _default = DoubleSlider;
exports["default"] = _default;